import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["splash"];

  connect() {
    this.setupClickListener();
  }

  setupClickListener() {
    // Listen for click events on the splash screen
    this.splashTarget.addEventListener("click", () => this.hideSplashScreen());
  }

  hideSplashScreen() {
    // Fade out and hide the splash screen
    this.splashTarget.classList.add("opacity-0"); // Fade out the splash screen
    this.splashTarget.classList.add("invisible"); // Make it disappear from layout
  }
}

